/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { bool, func, shape } from 'prop-types';
import { connect } from 'formik';
import FormPreventNavigation from 'components/Form/PreventNavigation/PreventNavigation';
import useDebounce from 'utils/useDebounce';

function Form({ formik: { handleReset, handleSubmit, dirty }, ...props }) {
  const debouncedSubmit = useDebounce(handleSubmit, 300, true);

  function handleKeyDown(e) {
    // Allow Enter key in TEXTAREA elements and Monaco editor
    const isTextarea = e.target.tagName === 'TEXTAREA';
    const isMonacoEditor = e.target.closest('.monaco-editor') !== null;

    if (e.keyCode === 13 && !isTextarea && !isMonacoEditor) {
      e.preventDefault();
    }
  }

  return (
    <FormPreventNavigation
      dirty={dirty}
      unblockNavigationRoute={props.unblockNavigationRoute}
      unblockNavigationRouteKeepReferrer={
        props.unblockNavigationRouteKeepReferrer ?? ''
      }
    >
      <form
        onKeyDown={handleKeyDown}
        onReset={handleReset}
        onSubmit={debouncedSubmit}
        {...props}
      />
    </FormPreventNavigation>
  );
}

Form.propTypes = {
  formik: shape({
    handleReset: func.isRequired,
    handleSubmit: func.isRequired,
    dirty: bool,
    isSubmitting: bool,
  }).isRequired,
};

export default connect(Form);
